"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClusterZoomIn = void 0;
const react_1 = __importDefault(require("react"));
const useScreenSizeDetection_1 = __importDefault(require("../../../../../../utils/useScreenSizeDetection"));
const ClusterZoomIn_style_1 = require("./ClusterZoomIn.style");
const ZoomInIcon_1 = require("./ZoomInIcon/ZoomInIcon");
const ClusterZoomIn = ({ handleZoomIn, color }) => {
    const isMobile = (0, useScreenSizeDetection_1.default)();
    return (react_1.default.createElement(ClusterZoomIn_style_1.ZoomInContainer, { onClick: handleZoomIn, onTouchEnd: handleZoomIn, "$isMobile": isMobile },
        react_1.default.createElement(ZoomInIcon_1.ZoomInIcon, { color: color })));
};
exports.ClusterZoomIn = ClusterZoomIn;
